import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep" data-id="element-85" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-86" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl font-semibold text-gold" data-id="element-87" data-mp="3ghc2o28413o8">
          Paid Table Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-88" data-mp="32m1cv38q38qq">
          The Paid Table Loop, because preparing a paid table shouldn&apos;t cost
          you every evening of the week.
        </p>
        <p className="mx-auto mt-7 max-w-2xl border-t border-plum-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-89" data-mp="3ud7czjog16g0">
          Paid Table Ready is an independent, 5E-compatible product for Game
          Masters. It does not replace your own judgment about your table, your
          players or the rules of the platform where you host your games. No
          income or specific results are promised.
        </p>
        {/* TODO: paste the exact SRD 5.2.1 CC-BY attribution text from page 2 of
            each volume here, unchanged, and add the support email. */}
        <p className="mx-auto mt-4 max-w-2xl text-xs text-white/45" data-id="element-90" data-mp="3la27uq37evt4">
          © Paid Table Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}